<button [id]="idVal" type="button" (click)="onClick.emit($event)" class="btn" [ngClass]="classes">
  {{ label }}
  <img src="assets/images/sort_a-z.png" alt="Logo" width="24" height="28" >
</button>
